import { cn } from '@rocco/utils/cn';

interface FormHeaderProps {
    title: string;
    description?: string;
    variant?: 'default' | 'hde';
    className?: string;
}

export const FormHeader = ({
    title,
    description,
    variant = 'default',
    className,
}: FormHeaderProps) => {
    if (!title) {
        return null;
    }
    if (variant === 'hde') {
        return (
            <div
                className={cn(
                    'relative flex flex-col items-start justify-start pt-12 text-left',
                    className,
                )}
            >
                <h1 className="w-80 text-[1.31463rem] font-medium uppercase leading-[1.1] tracking-[-0.02631rem] text-[#161616]">
                    {title}
                </h1>
                {description && (
                    <p className="text-sm font-medium leading-[1.3] tracking-[-0.0185rem] text-black md:mt-[0.88rem] md:w-87">
                        {description}
                    </p>
                )}
            </div>
        );
    }

    return (
        <div
            className={cn(
                'flex flex-col items-center pb-9 text-center',
                description ? 'gap-7' : 'gap-0',
            )}
        >
            <h1 className="text-2xl font-medium text-gray-900">{title}</h1>
            {description && (
                <p
                    className="cms-inline-html mt-1 max-w-88.75 text-5.5 font-medium leading-normal text-gray-900"
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}
        </div>
    );
};
